import { render, staticRenderFns } from "./Develop.vue?vue&type=template&id=3f36cf79&scoped=true&"
import script from "./Develop.vue?vue&type=script&lang=js&"
export * from "./Develop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f36cf79",
  null
  
)

export default component.exports